export type PropData = number

export const DEFAULT_PROP_DATA: PropData = 0
